import { styled } from "goober";
import { forwardRef } from "react";

// Multiline input matching the standard Input's resting/focus treatment
// (no elevation shadow, control-bg focus ring) that grows with its content.
const Element = styled("textarea")`
  field-sizing: content;
  width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;
  background-color: var(--surface-primary);
  color: var(--text-primary);
  outline: 0.5px solid var(--border-alpha);
  border: 0;
  border-radius: 8px;
  resize: none;
  font-family: InterVariable;
  font-size: 12px;
  line-height: 16px;
  transition: box-shadow 100ms ease-out;

  &::placeholder {
    opacity: 0.3;
  }

  &:focus {
    outline: 0.5px solid var(--control-bg);
    box-shadow: 0 0 0 3px var(--border-alpha);
    &::placeholder {
      opacity: 0.6;
    }
  }

  &:disabled {
    background-color: var(--alpha4);
    cursor: not-allowed;
  }
`;

type Props = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const NoteTextarea = forwardRef<HTMLTextAreaElement, Props>(
  function NoteTextarea(props, ref) {
    return <Element rows={1} {...props} ref={ref} />;
  }
);
